import { INeoAction } from '../../Actions.interface';
import { REQUEST_ACTIONS, STATUS } from '../../../Constants/Actions.constants';
import { IServiceProviderCategories } from '~/Models/DTO/ServiceProviderCategories.models';

export default (
  state: IServiceProviderCategories[] = [],
  action: INeoAction,
): IServiceProviderCategories[] => {
  const { name, status, payload } = action;

  if (status === STATUS.SUCCESS) {
    if (name === REQUEST_ACTIONS.PROVIDER_CATEGORY_LIST) {
      return payload.service_provider_categories;
    }
  }
  return state;
};
